import { Virtuoso } from 'react-virtuoso';
import { useMemo } from 'react';
import { normalizeWebsiteSearch } from 'utils';
import AppItem from './AppItem';

export const Content = ({
  foundedApps,
  search,
  handleClose,
  setChoosedApp,
  choosedApp,
  isWebsite = false,
}) => {
  const normalizedSearch = useMemo(() => {
    if (!isWebsite || !search) return search;
    return normalizeWebsiteSearch(search);
  }, [isWebsite, search]);

  return (
    <Virtuoso
      data={foundedApps}
      itemContent={(index, rowData) => (
        <>
          <AppItem
            {...rowData}
            key={rowData.pba_number}
            search={normalizedSearch}
            handleClose={handleClose}
            choosedApp={choosedApp}
            setChoosedApp={setChoosedApp}
          />
        </>
      )}
    />
  );
};
